export default "__VITE_ASSET__Cs9NaESN__"